module.exports = __webpack_public_path__ + "img/template01.a854bd59.png";